import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { QuotaPreviewData, StageKey } from '../../../quotas/models/quota-preview.interface';
import { KgToTonsPipe } from '../../../../shared/pipes/kg-to-tons.pipe';

export interface QuotaPreviewDialogData {
  data: QuotaPreviewData | null;
  stage: StageKey | null;
  quotaName: string;
}

@Component({
  selector: 'app-quota-preview-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatChipsModule,
    KgToTonsPipe
  ],
  templateUrl: './quota-preview-dialog.component.html',
  styleUrl: './quota-preview-dialog.component.css'
})
export class QuotaPreviewDialogComponent {
  data = inject<QuotaPreviewDialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<QuotaPreviewDialogComponent>);

  displayedColumns: string[] = [
    'supplierName',
    'allocatedVolume',
    'individualHistoricalVolume',
    'stageQuotaVolume',
    'allocationPercentage'
  ];

  getStageTitle(stage: StageKey | null): string {
    if (!stage) return '—';
    const titles: Record<StageKey, string> = {
      'STAGE_1': 'Этап 1',
      'STAGE_2': 'Этап 2',
      'STAGE_3': 'Этап 3',
      'STAGE_FOR_NEW_SUPPLIERS': 'Распределение для новых поставщиков'
    };
    return titles[stage];
  }

  close(): void {
    this.dialogRef.close();
  }
}
